import React, { useEffect, useState, Children } from 'react';
import { Award, CheckCircle, Users } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function TrustBar() {
  const {
    t
  } = useLanguage();
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);
  const stats = [{
    icon: Award,
    text: t.trustBar.years
  }, {
    icon: CheckCircle,
    text: t.trustBar.projects
  }, {
    icon: Users,
    text: t.trustBar.family
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="bg-brand-blue py-12 relative z-20 -mt-8 mx-4 sm:mx-8 lg:mx-auto max-w-6xl rounded-xl shadow-2xl border border-white/10" data-id="element-229">
      <motion.div ref={ref} variants={containerVariants} initial="hidden" animate={controls} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 divide-y md:divide-y-0 md:divide-x divide-white/20" data-id="element-231">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <motion.div key={index} variants={itemVariants} className={`flex flex-col items-center text-center px-4 ${index !== 0 ? 'pt-8 md:pt-0' : ''}`} data-id="element-232">
                <div className="bg-white/10 p-4 rounded-full mb-4" data-id="element-233">
                  <Icon className="w-8 h-8 text-brand-red" data-id="element-234" />
                </div>
                <h3 className="text-white font-heading font-bold text-xl md:text-2xl" data-id="element-235">
                  {stat.text.split(' ')[0]}
                </h3>
                <p className="text-blue-100 font-medium mt-1" data-id="element-236">
                  {stat.text.split(' ').slice(1).join(' ')}
                </p>
              </motion.div>;
        })}
        </div>
      </motion.div>
    </section>;
}